<template>
  <div class="cms-readonly-item">
    <div class="cms-readonly-item-header">
      <div>
        <h4>{{ title }}</h4>
        <p v-if="subtitle" class="cms-readonly-subtitle">{{ subtitle }}</p>
      </div>
      <div v-if="badges.length > 0" class="cms-readonly-stats">
        <span v-for="(badge, index) in badges" :key="index" class="cms-stat-badge">
          {{ badge }}
        </span>
      </div>
    </div>
    <p v-if="content" class="cms-readonly-content">{{ content }}</p>
    <slot></slot>
    <cms-button
      v-if="showRemove"
      variant="danger"
      size="sm"
      icon="trash"
      @click="$emit('remove')"
    >
      {{ removeText }}
    </cms-button>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import CmsButton from './CmsButton.vue';

interface Props {
  title: string;
  subtitle?: string;
  content?: string;
  badges?: string[];
  showRemove?: boolean;
  removeText?: string;
}

const props = withDefaults(defineProps<Props>(), {
  badges: () => [],
  showRemove: true
});

const { t } = useI18n();
const removeText = props.removeText || t('general.remove');

defineEmits<{
  (e: 'remove'): void;
}>();
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-readonly-item {
  background: $cms-background-light;
  border-radius: $cms-radius-md;
  padding: $cms-spacing-md;
  border: 1px solid $cms-border-color;
  margin-bottom: $cms-spacing-md;
  
  h4 {
    margin: 0 0 0.25rem 0;
    font-size: $cms-font-size-md;
    font-weight: 600;
    color: $cms-text-primary;
  }
}

.cms-readonly-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  gap: $cms-spacing-md;
}

.cms-readonly-subtitle {
  margin: 0;
  font-size: $cms-font-size-sm;
  color: $cms-text-secondary;
}

.cms-readonly-stats {
  display: flex;
  gap: $cms-spacing-sm;
  flex-wrap: wrap;
  align-items: center;
}

.cms-stat-badge {
  background: #e1f5fe;
  color: #0277bd;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: $cms-font-size-xs;
  font-weight: 500;
  white-space: nowrap;
}

.cms-readonly-content {
  margin: 0.5rem 0;
  color: #495057;
  font-size: $cms-font-size-base;
  line-height: 1.5;
}
</style>



